var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShare = function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.793 4.543a1 1 0 0 1 1.414 0l4.5 4.5a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414-1.414l2.793-2.793H15.75a8.01 8.01 0 0 0-7.75 6 1 1 0 0 1-1.937-.5 10.01 10.01 0 0 1 9.687-7.5h2.836l-2.793-2.793a1 1 0 0 1 0-1.414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7.25a1 1 0 0 1 1 1v11h14a1 1 0 1 1 0 2H3.75A1.75 1.75 0 0 1 2 19.5V8.25a1 1 0 0 1 1-1"
  }))));
};
export default SvgIconShare;